import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import TaskTemplateForm from "../../components/maintenance/TaskTemplateForm";
import {
  fetchTaskTemplate,
  fetchTaskTemplateSuccess,
  fetchTaskTemplateFailure,
  createTaskTemplate,
  createTaskTemplateSuccess,
  createTaskTemplateFailure,
  updateTaskTemplate,
  updateTaskTemplateSuccess,
  updateTaskTemplateFailure,
  clearCurrentTaskTemplate,
} from "../../store/maintenance/actions";

const TaskTemplateFormContainer = ({
  template,
  loading,
  error,
  fetchTaskTemplate,
  createTaskTemplate,
  updateTaskTemplate,
  clearCurrentTaskTemplate,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  useEffect(() => {
    if (isEdit) {
      fetchTaskTemplate(id);
    }

    return () => {
      clearCurrentTaskTemplate();
    };
  }, [id, isEdit, fetchTaskTemplate, clearCurrentTaskTemplate]);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        if (isEdit) {
          await updateTaskTemplate(id, data);
        } else {
          await createTaskTemplate(data);
        }
        navigate("/maintenance/task-templates");
      } catch (err) {
        console.error("Error saving template:", err);
      }
    },
    [isEdit, id, createTaskTemplate, updateTaskTemplate, navigate]
  );

  return (
    <TaskTemplateForm
      template={template}
      loading={loading}
      error={error}
      isEdit={isEdit}
      onSubmit={handleSubmit}
    />
  );
};

const mapStateToProps = (state) => ({
  template: state.maintenance.taskTemplates.current,
  loading: state.maintenance.taskTemplates.loading,
  error: state.maintenance.taskTemplates.error,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTaskTemplate: (id) => {
    dispatch(fetchTaskTemplate(id)).payload.then(
      (response) => {
        dispatch(fetchTaskTemplateSuccess(response.data));
      },
      (error) => {
        dispatch(fetchTaskTemplateFailure(error.response?.data || error));
      }
    );
  },
  createTaskTemplate: (data) => {
    return dispatch(createTaskTemplate(data)).payload.then(
      (response) => {
        dispatch(createTaskTemplateSuccess(response.data));
      },
      (error) => {
        dispatch(createTaskTemplateFailure(error.response?.data || error));
        throw error;
      }
    );
  },
  updateTaskTemplate: (id, data) => {
    return dispatch(updateTaskTemplate(id, data)).payload.then(
      (response) => {
        dispatch(updateTaskTemplateSuccess(response.data));
      },
      (error) => {
        dispatch(updateTaskTemplateFailure(error.response?.data || error));
        throw error;
      }
    );
  },
  clearCurrentTaskTemplate: () => dispatch(clearCurrentTaskTemplate()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplateFormContainer);
